import React from 'react';
import styled from 'styled-components';
import { primary } from '@salutejs/plasma-tokens-b2c';

const StyledRoot = styled.svg`
    display: inline-flex;
    width: 1.375rem;
    height: 1.375rem;
    flex: 0 0 1.375rem;
`;

export const IconTelegram: React.FC<{ color?: string }> = ({ color = primary }) => {
    return (
        <StyledRoot width="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color}>
            <path
                d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM12.9856 8.85263L5.57801 11.9047L5.57728 11.9048C4.27378 12.4133 5.03681 12.8902 5.03681 12.8902C5.03681 12.8902 6.14955 13.2717 7.10325 13.5578C8.05695 13.8439 8.56571 13.526 8.56571 13.526L13.0484 10.5057C14.638 9.42472 14.2565 10.3149 13.8749 10.6964C13.0485 11.523 11.6814 12.8265 10.5368 13.8756C10.0282 14.3206 10.2824 14.7023 10.505 14.8929C11.1521 15.4404 12.6759 16.436 13.3683 16.8884C13.5604 17.0139 13.6885 17.0976 13.7161 17.1183C13.8749 17.2455 14.7642 17.8177 15.3056 17.6906C15.847 17.5634 15.9106 16.8322 15.9106 16.8322L16.7053 11.841C16.7754 11.3771 16.8454 10.9228 16.9108 10.4987C17.0829 9.3826 17.2228 8.47572 17.2458 8.15322C17.3412 7.07238 16.1967 7.51742 16.1967 7.51742C16.1967 7.51742 13.7168 8.53473 12.9856 8.85263Z"
                fill="currentColor"
            />
        </StyledRoot>
    );
};
